import React from 'react';
import { v4 as uuid } from 'uuid';
import { ModalBase } from 'Permafrost/index';
import { StyledContentModal } from './ContentModal.styles';
export function ContentModal(props) {
    const id = uuid();
    const labelText = 'labelText' in props && props.labelText;
    const title = 'title' in props && props.title;
    const { children, className, closeModal, describedBy, modalNode, open, width } = props;
    return (React.createElement(ModalBase, { className: className, clickToDismiss: closeModal, "data-cy": props['data-cy'], describedBy: describedBy, id: props.id, labelElement: title ? id : '', labelText: labelText || '', node: modalNode, open: open },
        React.createElement(StyledContentModal, { style: { width: width || 555 } },
            title && (React.createElement("div", { id: id, className: "title" }, title)),
            children)));
}
//# sourceMappingURL=ContentModal.js.map